/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scrape_Router_Step_CheapestInputs */

const en_scrape_router_step_cheapest = /** @type {(inputs: Scrape_Router_Step_CheapestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheapest scraper`)
};

const zh_hans1_scrape_router_step_cheapest = /** @type {(inputs: Scrape_Router_Step_CheapestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最便宜的抓取器`)
};

const pt_br2_scrape_router_step_cheapest = /** @type {(inputs: Scrape_Router_Step_CheapestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scraper mais barato`)
};

const es_scrape_router_step_cheapest = /** @type {(inputs: Scrape_Router_Step_CheapestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scraper más barato`)
};

const fr_scrape_router_step_cheapest = /** @type {(inputs: Scrape_Router_Step_CheapestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scraper le moins cher`)
};

const de_scrape_router_step_cheapest = /** @type {(inputs: Scrape_Router_Step_CheapestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günstigster Scraper`)
};

const ru_scrape_router_step_cheapest = /** @type {(inputs: Scrape_Router_Step_CheapestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самый дешёвый скрапер`)
};

const it_scrape_router_step_cheapest = /** @type {(inputs: Scrape_Router_Step_CheapestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scraper più economico`)
};

/**
* | output |
* | --- |
* | "Cheapest scraper" |
*
* @param {Scrape_Router_Step_CheapestInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const scrape_router_step_cheapest = /** @type {((inputs?: Scrape_Router_Step_CheapestInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scrape_Router_Step_CheapestInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_scrape_router_step_cheapest(inputs)
	if (locale === "pt-BR") return pt_br2_scrape_router_step_cheapest(inputs)
	if (locale === "es") return es_scrape_router_step_cheapest(inputs)
	if (locale === "fr") return fr_scrape_router_step_cheapest(inputs)
	if (locale === "de") return de_scrape_router_step_cheapest(inputs)
	if (locale === "ru") return ru_scrape_router_step_cheapest(inputs)
	if (locale === "it") return it_scrape_router_step_cheapest(inputs)
	return en_scrape_router_step_cheapest(inputs)
});